import gql from 'graphql-tag'

export const GET_RESELLERS = gql`
query getResellers {
  resellers {
    nodes {
      id
      name
    }
  }
}

`

export default {
  GET_RESELLERS
}
